var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNameRemindersnotifications(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 342,
    viewBox: "0 0 363 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.124 280.522H43.3144C37.5905 280.522 32.9492 275.881 32.9492 270.157V91.442C32.9492 85.718 37.5905 81.0768 43.3144 81.0768H171.124C176.848 81.0768 181.49 85.718 181.49 91.442V174.73",
    stroke: "#5109C9",
    strokeWidth: 7.69692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0103 81.0769V59.369C70.0103 53.645 74.6515 49.0038 80.3754 49.0038H208.185C213.909 49.0038 218.551 53.645 218.551 59.369V142.66",
    stroke: "#5109C9",
    strokeWidth: 7.69692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5044 107.475H77.517",
    stroke: "#5109C9",
    strokeWidth: 6.4141,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5044 121.132H98.2166",
    stroke: "#5109C9",
    strokeWidth: 6.4141,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5044 149.644H77.517",
    stroke: "#5109C9",
    strokeWidth: 6.4141,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5044 163.301H98.2166",
    stroke: "#5109C9",
    strokeWidth: 6.4141,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5044 199.997H77.517",
    stroke: "#5109C9",
    strokeWidth: 6.4141,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5044 213.654H98.2166",
    stroke: "#5109C9",
    strokeWidth: 6.4141,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5044 233.984H77.517",
    stroke: "#5109C9",
    strokeWidth: 6.4141,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5044 247.641H98.2166",
    stroke: "#5109C9",
    strokeWidth: 6.4141,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M200.478 289.32L191.208 292.668C188.427 293.671 185.346 292.224 184.343 289.443L171.52 253.927L187.36 248.213L197.689 276.825C198.328 278.598 199.636 279.932 200.899 281.22C202.063 282.405 203.159 283.524 203.636 284.848C204.673 287.719 200.909 289.171 200.478 289.322V289.32Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.769692,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M195.085 239.99L190.423 241.676L188.022 242.541L185.623 243.408L169.788 249.127L167.384 249.994L164.985 250.858L164.592 250.994C153.95 254.673 142.325 249.114 138.505 238.523C137.671 236.211 137.278 233.853 137.278 231.529C137.278 223.06 142.546 215.122 150.989 212.125L181.164 201.418L185.659 213.872L195.09 239.99H195.085Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.769692,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M280.841 204.551L269.573 173.332C270.16 173.273 270.753 173.24 271.338 173.24C278.34 173.24 284.923 177.576 287.432 184.529C290.154 192.069 287.229 200.29 280.841 204.551Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.769692,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.694 244.496C263.841 240.593 256.504 237.722 248.797 235.931C242.418 234.454 235.778 233.71 228.995 233.71C227.053 233.71 225.095 233.769 223.127 233.892C212.252 234.569 203.859 236.94 199.888 238.261L190.651 212.671L185.961 199.684C187.914 198.927 190.88 197.66 194.461 195.784C198.043 193.904 202.238 191.412 206.635 188.198C213.776 182.982 219.982 176.937 225.08 170.233C229.867 163.934 233.677 157.038 236.458 149.659L249.584 186.022L251.791 192.126L255.157 201.447L257.358 207.55L270.697 244.493L270.694 244.496Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.769692,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.693 230.077C152.567 230.077 151.51 229.379 151.105 228.258C150.589 226.829 151.328 225.251 152.759 224.735L171.435 217.992C172.864 217.477 174.442 218.218 174.957 219.647C175.473 221.076 174.734 222.654 173.303 223.17L154.627 229.912C154.319 230.023 154.004 230.077 153.693 230.077Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.769692,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157 239.711C155.874 239.711 154.817 239.013 154.411 237.892C153.896 236.463 154.635 234.885 156.066 234.369L174.741 227.626C176.171 227.108 177.748 227.85 178.264 229.281C178.78 230.71 178.041 232.288 176.609 232.804L157.934 239.546C157.626 239.659 157.31 239.711 157 239.711Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.769692,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M286.686 254.773C285.07 255.361 283.317 255.276 281.757 254.55C280.695 254.05 279.818 253.288 279.176 252.344C278.876 251.9 278.617 251.42 278.432 250.899L264.142 211.311L262.982 208.102L261.645 204.389L254.905 185.724L253.564 182.004L252.404 178.795L238.257 139.604C238.067 139.076 237.949 138.534 237.9 137.996C237.641 135.148 239.319 132.367 242.134 131.351C245.477 130.145 249.181 131.884 250.387 135.227L262.874 169.817L263.741 172.216L264.609 174.625L276.195 206.722L277.062 209.131L277.929 211.53L290.56 246.517C291.766 249.86 290.026 253.565 286.683 254.771L286.686 254.773Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.769692,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M325.283 167.575L301.813 176.049C300.958 176.357 300.276 176.981 299.891 177.802C299.506 178.623 299.463 179.546 299.771 180.401C300.255 181.745 301.541 182.646 302.967 182.646C303.36 182.646 303.75 182.576 304.122 182.443L327.592 173.969C329.355 173.332 330.271 171.38 329.635 169.617C328.998 167.855 327.046 166.936 325.283 167.575Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.769692,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M296.448 133.688C295.622 133.313 294.699 133.283 293.849 133.601C293 133.922 292.325 134.553 291.951 135.379L281.645 158.105C280.87 159.811 281.629 161.831 283.335 162.605C283.782 162.808 284.251 162.911 284.739 162.911C286.07 162.911 287.286 162.128 287.835 160.915L298.142 138.188C298.916 136.482 298.157 134.463 296.451 133.688H296.448Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.769692,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M326.248 211.635L303.403 201.598C301.687 200.844 299.678 201.626 298.924 203.343C298.559 204.174 298.539 205.097 298.867 205.944C299.196 206.791 299.837 207.458 300.668 207.822L323.513 217.862C323.946 218.051 324.408 218.149 324.878 218.149C326.227 218.149 327.448 217.351 327.992 216.117C328.357 215.286 328.377 214.362 328.049 213.515C327.72 212.669 327.079 212.002 326.248 211.637V211.635Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.769692,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameRemindersnotifications);
export default __webpack_public_path__ + "static/media/Name=Reminders & notifications.fad0c445ecbc58d2fa14e04fb73a0195.svg";
export { ForwardRef as ReactComponent };